document.addEventListener("DOMContentLoaded", function () {
    // Select the span containing the shipping info
    const shippingLabel = document.querySelector(".product-label--custom");

    // Check if the span exists and contains "15"
    if (shippingLabel && shippingLabel.textContent.includes("15")) {
        // Select the div with the class .px-low-stock
        const lowStockDiv = document.querySelector(".px-low-stock");
        if (lowStockDiv) {
            lowStockDiv.style.display = "block"; // Show the div
        }
    }


  readMoreToggle();
});


/* Handles the "Lire plus / Voir moins" toggle behavior for `.px-cat-short` small description */
window.addEventListener("resize", readMoreToggle);

function readMoreToggle() {
  document.querySelectorAll("#template--25297214013778__rich_text_EzcGpa .px-cat-short").forEach(container => {
    const showMoreBtn = container.nextElementSibling;

    const lineHeight = parseFloat(window.getComputedStyle(container).lineHeight);
    const twoLineHeight = lineHeight * 2;
    const fullHeight = container.scrollHeight;

    if (window.innerWidth <= 600 && fullHeight > twoLineHeight) {
      if (!container.classList.contains("has-read-more")) {
        // Add clamp
        container.style.maxHeight = `${twoLineHeight}px`;
        container.style.overflow = "hidden";
        container.classList.add("has-read-more");

        // Create and insert button
        const btn = document.createElement("span");
        btn.textContent = "Lire plus";
        btn.className = "show-more-btn";

        container.insertAdjacentElement("afterend", btn);

        btn.addEventListener("click", () => {
          const expanded = container.classList.toggle("expanded");
          container.style.maxHeight = expanded ? `${fullHeight}px` : `${twoLineHeight}px`;
          btn.textContent = expanded ? "Voir moins" : "Lire plus";
        });
      }
    } else if (window.innerWidth >= 600 || fullHeight <= twoLineHeight) {
      // Desktop: Remove clamp and button
      container.style.maxHeight = "none";
      container.style.overflow = "visible";
      container.classList.remove("has-read-more", "expanded");

      // Remove button if exists and is next sibling
      if (showMoreBtn && showMoreBtn.classList.contains("show-more-btn")) {
        showMoreBtn.remove();
      }
    }
  });
}


/* Hide the Elfsight Google Reviews badge or watermark link */

const observer = new MutationObserver(() => {
  const links1 = document.querySelectorAll('.WidgetBackground__Content-sc-49882ea2-2.hOgWlG.WidgetBackground__ContentContainer-sc > a[href*="elfsight.com"]');
  const links2 = document.querySelectorAll('.WidgetBackground__Content-sc-7c0ce009-2.fxmDQB.WidgetBackground__ContentContainer-sc > a[href*="elfsight.com"]');

  if (links1.length > 0 || links2.length > 0) {
    setTimeout(() => {
      links1.forEach(link => link.remove());
      links2.forEach(link => link.remove());
      observer.disconnect();
    }, 1000); // safe delay
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

